import { Trans } from "@lingui/macro";
import {
  ResultHeaderTitle,
  ResultHeaderWrapper,
} from "../SearchResults.styled";
import { HyperLink } from "src/atoms/HyperLink";

type ResultHeaderProps = {
  title: string | React.ReactNode;
  viewAllText?: string | React.ReactNode;
  viewAllLink?: string;
  onViewAllClick?: () => void;
  /** When true, the view-all link gets data-cnstrc-search-submit-btn so the
   * Constructor beacon treats clicking it as the user submitting their query. */
  isSearchSubmit?: boolean;
};

function ResultHeader({
  title,
  viewAllLink,
  viewAllText,
  onViewAllClick,
  isSearchSubmit = false,
}: ResultHeaderProps) {
  return (
    <ResultHeaderWrapper>
      <ResultHeaderTitle as="h3">{title}</ResultHeaderTitle>
      {viewAllLink ? (
        <HyperLink
          href={viewAllLink}
          hasUnderline
          onClick={onViewAllClick}
          {...(isSearchSubmit && { "data-cnstrc-search-submit-btn": "" })}
        >
          {viewAllText ? viewAllText : <Trans>View all</Trans>}
        </HyperLink>
      ) : null}
    </ResultHeaderWrapper>
  );
}

export { ResultHeader };
